<template>
    <div class="administration">
        <Row>
            <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
                <Col :xs="24" :sm="24">
                    <FormItem>
                        <Button type="primary" class="btn_view" size="small" ghost @click="newImg">
                            <div class="btn_wrap">
                                <img src="/statics/console/img/upload.png" alt class="btn_icon"/>
                                <span class="wenzi">上传</span>
                            </div>
                        </Button>
                    </FormItem>
                    <FormItem>
                        <Button type="success" class="btn_view add_btn" size="small" ghost @click="newFolder">
                            <div class="btn_wrap">
                                <img src="/statics/console/img/add.png" alt class="btn_icon"/>
                                <span class="wenzi">新建</span>
                            </div>
                        </Button>
                    </FormItem>
                    <FormItem>
                        <Input v-model="formItem.media_name" clearable placeholder="名称"></Input>
                    </FormItem>
                    <FormItem>
                        <Input v-model="formItem.tag" clearable placeholder="标签"></Input>
                    </FormItem>
                    <FormItem>
                        <DatePicker
                                :value="formItem.datetime"
                                type="datetimerange"
                                @on-change="changeDate"
                                style="width: 320px"
                                placeholder="开始时间-结束时间"
                        ></DatePicker>
                    </FormItem>
                    <FormItem>
                        <Button type="primary" size="small" class="btn_view search_all_btn" @click="getIndex">
                            <div class="btn_wrap">
                                <img src="/statics/console/img/search.png" alt class="btn_icon"/>
                                <span class="wenzi">查询</span>
                            </div>
                        </Button>
                    </FormItem>
                </Col>
                <!-- 操作按钮 -->
                <Col :xs="24" :sm="24" v-if="zhongId && floderDetail">
                    <!-- v-if="zhongId&&floderDetail.can_change" -->
                    <FormItem>
                        <Button
                                type="success"
                                :class=" renameStatus ? 'btn_view rename_btn clicked' : 'btn_view rename_btn' "
                                ghost
                                :disabled="removeStatus"
                                size="small"
                        >
                            <div class="btn_wrap" @click="clickRename">
                                <img src="/statics/console/img/edit_icon.png" alt class="btn_icon"/>
                                <span class="wenzi">编辑</span>
                            </div>
                        </Button>
                    </FormItem>
                    <!-- v-if="zhongId&&floderDetail.can_change" -->
                    <FormItem>
                        <Button
                                type="success"
                                :class=" removeStatus ? 'btn_view remove_btn clicked' : 'btn_view remove_btn' "
                                ghost
                                :disabled="renameStatus"
                                size="small"
                        >
                            <div class="btn_wrap" @click="clickRemove">
                                <img src="/statics/console/img/del_icon.png" alt class="btn_icon"/>
                                <span class="wenzi">删除</span>
                            </div>
                        </Button>
                    </FormItem>
                </Col>
            </Form>
        </Row>
        <!-- 面包屑导航 -->
        <div id="crumbs" style="display: flex;border-bottom: 1px solid rgba(0,0,0,0.12);">
            <ul style="padding-bottom: 20px;" class="mbx">
                <li v-if="parentid > 0" @click="findChind(-1)">
                    <img src="/statics/console/img/back.png" alt class="back"/>
                </li>
                <li v-for="(item,index) in bread_crumbs" :key="index" @click="findChind(item.id)">
                    <a>{{item.name}}</a>
                </li>
            </ul>
        </div>
        <div class="foldercon">
            <!-- 左侧文件 -->
            <div class="item_list clearfix">
                <div
                        v-for="(item,index) in list"
                        :key="index"
                        :class="renameStatus || removeStatus ? 'file_item custom_select' :  'file_item'"
                        @mouseover="mouseOver(index,item.id)"
                        @mouseleave="mouseLeave()"
                >
                    <div class="zhezhao" style="display:none">
                        <Checkbox v-model="item.single" @on-change="changeCheck($event,index,item.id)"></Checkbox>
                    </div>
                    <!-- 文件夹 -->
                    <div
                            class="item_wrap"
                            @dblclick="findChind(item.id)"
                            v-if="item.type==1"
                            v-drag="greet"
                            @mousedown="mousedown(item)"
                            @mouseleave="mouseleave(item.id,item.type)"
                            @mouseenter="mouseenter(item.id,item.type)"
                    >
                        <!-- 文件夹图片 -->
                        <div class="item_tu_wrap">
                            <img src="/statics/console/img/folder.png" class="tu_folder" v-if="item.type == 1"/>
                        </div>
                        <!-- 文件夹名称 -->
                        <div
                                style="text-align: center;overflow:hidden;padding-top:10px;font-size: 12px;color: #333333"
                        >
                            <span class="title" :title="item.media_name">{{ item.media_name }}</span>
                        </div>
                        <!-- 文件夹创建时间 -->
                        <div style="text-align: center;overflow:hidden;font-size: 12px;color: #666666">
                            <span>{{ item.created_at }}</span>
                        </div>
                        <div class="select_icon" v-if="item.id == renameId && renameStatus">
                            <img src="/statics/console/img/del_icon.png" alt class="btn_icon"/>
                        </div>
                        <div class="remove_icon" v-if="item.id == renameId && removeStatus">
                            <img src="/statics/console/img/edit_icon.png" alt class="btn_icon"/>
                        </div>
                        <div class="select_icon wait_rename" v-if=" item.id != renameId && renameStatus">
                            <img src="/statics/console/img/edit_icon.png" alt class="btn_icon"/>
                        </div>
                        <div class="remove_icon wait_rename" v-if=" item.id != renameId && removeStatus">
                            <img src="/statics/console/img/del_icon.png" alt class="btn_icon"/>
                        </div>
                    </div>
                    <!-- 图片 -->
                    <div
                            class="item_wrap"
                            v-else
                            v-drag="greet"
                            @dblclick="downloadImg(addmin(item.path))"
                            @mousedown="mousedown(item)"
                            @mouseleave="mouseleave(item.id,item.type)"
                            @mouseenter="mouseenter(item.id,item.type)"
                    >
                        <!-- 图 -->
                        <div class="item_tu_wrap">
                            <img src="/statics/console/img/folder.png" class="tu_folder" v-if="item.type == 1"/>
                            <!-- 图片放大 -->
                            <viewer :images="[addmin(item.path)]">
                                <img
                                        :src="addmin(item.path)"
                                        v-if="item.type ==2 && item.file_type=='pic'"
                                        class="item_tu"
                                />
                            </viewer>
                            <img
                                    src="/statics/console/img/file/excel.png"
                                    v-if="item.type ==2 && item.file_type=='excel'"
                            />
                            <img
                                    src="/statics/console/img/file/pdf.png"
                                    v-if="item.type ==2&&item.file_type=='pdf'"
                            />
                            <img
                                    src="/statics/console/img/file/ppt.png"
                                    v-if="item.type ==2&&item.file_type=='ppt'"
                            />
                            <img
                                    src="/statics/console/img/file/txt.png"
                                    v-if="item.type ==2&&item.file_type=='txt'"
                            />
                            <img
                                    src="/statics/console/img/file/word.png"
                                    v-if="item.type ==2 && item.file_type=='word'"
                            />
                            <img
                                    src="/statics/console/img/file/zip.png"
                                    v-if="item.type ==2 && item.file_type=='zip'"
                            />
                            <img
                                    src="/statics/console/img/file/else.png"
                                    v-if="item.type ==2 && item.file_type=='else'"
                            />
                            <Video
                                    :src="addmin(item.path)"
                                    v-if="item.type ==2 && item.file_type=='video'"
                                    style="max-width:100%;max-height:100%"
                                    controls
                                    footer-hide
                            ></Video>
                        </div>
                        <!-- 图片名称 -->
                        <div
                                style="text-align: center;overflow:hidden;padding-top:10px;font-size: 12px;color: #333333"
                        >
                            <span class="title" :title="item.media_name">{{ item.media_name }}</span>
                        </div>
                        <!-- 图片创建时间 -->
                        <div style="text-align: center;overflow:hidden;font-size: 12px;color: #666666">
                            <span>{{ item.created_at }}</span>
                        </div>
                        <div class="select_icon" v-if="item.id == renameId && renameStatus">
                            <Icon type="ios-checkmark" color="#ffffff"/>
                        </div>
                        <div class="select_icon" v-if="item.id == renameId && removeStatus">
                            <Icon type="ios-checkmark" color="#ffffff"/>
                        </div>
                        <div class="select_icon wait_rename" v-if=" item.id != renameId && renameStatus">
                            <img src="/statics/console/img/edit_icon.png" alt class="btn_icon"/>
                        </div>
                        <div class="remove_icon wait_rename" v-if=" item.id != renameId && removeStatus">
                            <img src="/statics/console/img/del_icon.png" alt class="btn_icon"/>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 右侧详情 -->
            <div class="folderRight">
                <h3>文件详情</h3>
                <div class="nofloder" v-if="!floderDetail">
                    <img src="/statics/console/img/moren.png"/>
                    <span>请选择文件,查看详情</span>
                </div>
                <div class="picbox" v-if="floderDetail">
                    <img
                            v-if="floderDetail && floderDetail.type == 2&&floderDetail.file_type=='pic'"
                            :src="addmin(floderDetail.path)"
                            class="pic"
                    />
                    <img
                            v-if="floderDetail && floderDetail.type == 2&&floderDetail.file_type=='excel'"
                            src="/statics/console/img/file/excel.png"
                            class="pic"
                    />
                    <img
                            v-if="floderDetail && floderDetail.type == 2&&floderDetail.file_type=='pdf'"
                            src="/statics/console/img/file/pdf.png"
                            class="pic"
                    />
                    <img
                            v-if="floderDetail && floderDetail.type == 2&&floderDetail.file_type=='ppt'"
                            src="/statics/console/img/file/ppt.png"
                            class="pic"
                    />
                    <img
                            v-if="floderDetail && floderDetail.type == 2&&floderDetail.file_type=='txt'"
                            src="/statics/console/img/file/txt.png"
                            class="pic"
                    />
                    <img
                            v-if="floderDetail && floderDetail.type == 2&&floderDetail.file_type=='word'"
                            src="/statics/console/img/file/word.png"
                            class="pic"
                    />
                    <img
                            v-if="floderDetail && floderDetail.type == 2&&floderDetail.file_type=='zip'"
                            src="/statics/console/img/file/zip.png"
                            class="pic"
                    />
                    <img
                            v-if="floderDetail && floderDetail.type == 2&&floderDetail.file_type=='else'"
                            src="/statics/console/img/file/else.png"
                            class="pic"
                    />
                    <Video
                            :src="addmin(floderDetail.path)"
                            v-if="floderDetail && floderDetail.type == 2&&floderDetail.file_type=='video'"
                            style="max-width:100%;max-height:100%"
                            controls
                            footer-hide
                    ></Video>
                    <img src="/statics/console/img/folder.png" v-if="floderDetail && floderDetail.type == 1"/>
                </div>
                <div class="name" v-if="floderDetail">
                    <span>{{ floderDetail.media_name }}</span>
                </div>
                <div class="time" v-if="floderDetail&&floderDetail.path">
                    <span>规格:</span>
                    <i>{{ floderDetail.ext }}</i>
                </div>
                <div class="time" v-if="floderDetail&&floderDetail.path">
                    <span>链接:</span>
                    <i style="word-wrap:break-word">{{ floderDetail.path }}</i>
                </div>
                <div class="time" v-if="floderDetail">
                    <span>创建时间:</span>
                    <i>{{ floderDetail.created_at }}</i>
                </div>
                <div class="time" v-if="floderDetail">
                    <span>分类:</span>
                    <i>{{ floderDetail.category_name }}</i>
                </div>
                <div class="biao" v-if="floderDetail&&floderDetail.tags&&floderDetail.tags[0]">
                    <span>标签:</span>
                    <Tag
                            color="cyan"
                            v-for="(item,index) in floderDetail.tags"
                            :key="'labelsName'+index"
                    >{{ item.tag }}
                    </Tag>
                </div>
                <Button type="primary" v-if="floderDetail" @click="toshow" style="margin-top:10px">部门共享</Button>
                <br/>
                <!-- @click="downloadImg(addmin(floderDetail.url))" -->
                <Button type="primary" v-if="floderDetail&&floderDetail.type==2" style="margin-top:10px">
                    <a style="color: #fff;" :href="addmin(floderDetail.path)">下载</a>
                </Button>
                <br v-if="floderDetail&&floderDetail.type==2"/>
                <Button type="primary" v-if="floderDetail" @click="toshowfen" style="margin-top:10px">分享</Button>
                <!-- <div class="time" v-if="floderDetail">
                          分享：
                          <span style="color:#57a3f3;cursor: pointer;" @click="toshow">分享</span>
                </div>-->
            </div>
        </div>
        <!--新建文件夹-->
        <Drawer
                :closable="false"
                :mask-closable="false"
                :scrollable="true"
                :title="ftitle"
                width="640"
                v-model="showModalStatus"
        >
            <Form
                    :label-width="80"
                    ref="addInfo"
                    :model="addInfo"
                    :rules="addInfoValidate"
                    action="javascript:void(0)"
            >
                <FormItem prop="media_name" label="名称">
                    <Input v-model="addInfo.media_name" placeholder="请输入文件夹名称..."></Input>
                </FormItem>
                <FormItem
                        :label="'标签'+(index+1)"
                        prop="labels"
                        v-for="(item,index) in addInfo.tags"
                        :key="'labels'+index"
                >
                    <div style="display:flex;align-items: center;">
                        <Input v-model="item.tag" placeholder="请输入标签名称..."></Input>
                        <Icon
                                size="20"
                                type="ios-close-circle"
                                style="margin-left:10px;"
                                @click="deleteLable(index)"
                        />
                    </div>
                </FormItem>
                <Button style="margin-left: 80px;margin-bottom:100px;" @click="addLable">添加标签</Button>
                <FormItem>
                    <Button style="margin-right: 8px" @click="handleReset">取消</Button>
                    <Button type="primary" @click="handleSubmit('addInfo')">提交</Button>
                </FormItem>
            </Form>
        </Drawer>
        <!-- 上传图片 -->
        <Drawer
                :title="pictitle"
                :closable="false"
                v-model="showImgModalStatus"
                width="640"
                scrollable
                :mask-closable="false"
        >
            <RadioGroup v-model="fjway" style="margin-bottom:20px">
                <Radio label="pic">
                    <span>图片</span>
                </Radio>
                <Radio label="video">
                    <span>视频</span>
                </Radio>
                <Radio label="file">
                    <span>附件</span>
                </Radio>
            </RadioGroup>
            <Form
                    :label-width="80"
                    :model="imgInfo"
                    ref="imgInfo"
                    :rules="imgInfoValidate"
                    action="javascript:void(0)"
            >
                <FormItem prop="thumb" v-if="fjway=='pic'" label="缩略图">
                    <!-- 配置 parentid-->
                    <upload-thumb ref="uploadthumb" :defaultList="thumblist" :max-num="1"></upload-thumb>
                </FormItem>
                <FormItem prop="video" v-if="fjway == 'video'" label="上传视频">
                    <slice-upload-video ref="sliceuploadvideo" :defaultList="videoList"></slice-upload-video>
                </FormItem>
                <FormItem prop="file" v-if="fjway=='file'" label="上传附件">
                    <upload-file ref="UploadFiles" :defaultList="fileList"></upload-file>
                </FormItem>
                <FormItem prop="media_name" label="名称">
                    <Input v-model="imgInfo.media_name" placeholder="请输入名称..."></Input>
                </FormItem>
                <FormItem label="分类" prop="sort">
                    <Select
                            v-model="imgInfo.category_id"
                            clearable
                            :style="{'width':'180px'}"
                            placeholder="请选择分类"
                    >
                        <Option
                                v-for="item in categories"
                                :value="item.id"
                                :key="item.id"
                        >{{ item.category_name }}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem
                        :label="'标签'+(index+1)"
                        prop="piclabels"
                        v-for="(item,index) in imgInfo.tags"
                        :key="'labels'+index"
                >
                    <div style="display:flex;align-items: center;">
                        <Input v-model="item.tag" placeholder="请输入标签名称..."></Input>
                        <Icon
                                size="20"
                                type="ios-close-circle"
                                style="margin-left:10px;"
                                @click="deleteImgLable(index)"
                        />
                    </div>
                </FormItem>
                <Button style="margin-left: 80px;margin-bottom:100px;" @click="addImgLable">添加标签</Button>
                <FormItem>
                    <Button style="margin-right: 8px" @click="handleImgReset">取消</Button>
                    <Button type="primary" @click="handleImgSubmit('imgInfo')">提交</Button>
                </FormItem>
            </Form>
        </Drawer>
        <!-- 分享部门选择 -->
        <Modal v-model="showbumenList" title="部门" :closable="false" :mask-closable="false">
            <CheckboxGroup v-model="bumen">
                <Checkbox :label="item.id" v-for="(item,index) in sectionList" :key="index">
                    <span>{{item.name}}</span>
                </Checkbox>
            </CheckboxGroup>
            <div slot="footer">
                <Button type="primary" @click="submitbumen">确定</Button>
                <Button @click="cancelbumen">取消</Button>
            </div>
        </Modal>
        <!-- 分享 -->
        <Modal v-model="showshare" title :closable="true" :mask-closable="false" :footer-hide="true">
            <template #header>
                <span>分享文件(夹):文件名</span>
            </template>
            <!-- 有效期 -->
            <div style="display:flex;marginBottom:20px">
                <div style="width:80px">
                    <span>有效期：</span>
                </div>
                <div>
                    <RadioGroup v-model="animaltime">
                        <Radio label="1">1天</Radio>
                        <Radio label="2">7天</Radio>
                        <Radio label="3">30天</Radio>
                        <Radio label="4">永久有效</Radio>
                    </RadioGroup>
                </div>
            </div>
            <!-- 提取码 -->
            <div style="display:flex">
                <div style="width:80px">
                    <span>提取码：</span>
                </div>
                <div>
                    <RadioGroup v-model="animalma">
                        <Radio label="0" style="display:block;marginBottom:10px">系统随机生成提取码</Radio>
                        <Radio label="1" style="display:block">
                            <Input
                                    v-model="mavalue"
                                    placeholder="请输入4位提取码"
                                    style="width: 120px;marginRight:10px"
                                    :disabled="animalma == 0 ? true : false"
                            />
                            <span>仅支持数字及英文字母</span>
                        </Radio>
                    </RadioGroup>
                </div>
            </div>
            <!-- 按钮 -->
            <div style="textAlign: center;marginTop:20px">
                <Button type="primary" shape="circle" :loading="tochuangLoading" @click="tochuang">创建链接</Button>
            </div>
        </Modal>
        <!-- 链接展示 -->
        <Modal v-model="showlian" width="800" :footer-hide="true">
            <template #header>
                <p style="color:#4cb597;text-align:center">
                    <span>链接创建成功！</span>
                </p>
            </template>
            <div style="display: flex; height: 50px;line-height: 50px">
                <p>
                    链接:
                </p>
                <p id="share-link" style="font-size: 14px; margin-left: 10px">{{share_link}}</p>
                <p style="margin-left: 10px;font-size: 20px">
                    <a href="javascript:;" style="text-decoration: none;color:#000">
                        <Icon type="ios-copy" style="margin-top: -5px;" @click="copyLink('share-link')"/>
                    </a>
                </p>
            </div>
            <div style="display: flex;height: 50px;line-height: 50px">
                <p>
                    提取码:
                </p>
                <p id="share-link-code" style="font-size: 14px; margin-left: 10px">{{share_link_code}}</p>
                <p style="margin-left: 10px;font-size: 20px">
                    <a href="javascript:;" style="text-decoration: none;color:#000">
                        <Icon type="ios-copy" style="margin-top: -5px;" @click="copyLink('share-link-code')"/>
                    </a>
                </p>
            </div>
<!--            <template #footer>-->
<!--                <Button type="success" size="large" long @click="copyLink">复制链接</Button>-->
<!--            </template>-->
        </Modal>
    </div>
</template>

<script>
    // import UploadThumb from "../../../components/thumbnew";
    import UploadThumb from "../common/thumb";
    import SliceUploadVideo from "../common/videochapter";
    import UploadFile from "../common/uploadFile";

    export default {
        data() {
            const validateThumb = (rule, value, callback) => {
                if (this.$refs["uploadthumb"].uploadList.length == 0) {
                    callback(new Error("请上传图片"));
                } else {
                    callback();
                }
            };
            const validateVideo = (rule, value, callback) => {
                if (this.$refs["sliceuploadvideo"].videoList.length == 0) {
                    callback(new Error("请上传视频"));
                } else {
                    callback();
                }
            };
            const validateFile = (rule, value, callback) => {
                if (this.$refs["UploadFiles"].filesList.length == 0) {
                    callback(new Error("请上传附件"));
                } else {
                    callback();
                }
            };
            return {
                tochuangLoading: false,
                share_link: '',
                share_link_code: '',
                showshare: false, //分享弹出
                showlian: false, //链接弹出
                animaltime: "2", //有效期
                animalma: "0", //系统自动生成
                mavalue: "", //手动输入提取码
                classsName: "", //分类名
                fjway: "pic",
                showbumenList: false, //部门
                sectionList: [],
                bumen: [],
                ftitle: "",
                pictitle: "",
                parentid: 0, //父级id
                isX: false,
                zhongId: null, //选中的id
                // 查询
                formItem: {
                    media_name: "", //名称
                    tag: "", //标签
                    datetime: [] //开始时间-结束时间
                },
                // 新增文件夹
                showModalStatus: false,
                addInfo: {
                    media_name: "",
                    tags: [
                        {
                            tag: ""
                        }
                    ]
                },
                addInfoValidate: {
                    media_name: [{required: true, message: "请输入名称", trigger: "blur"}]
                }, // 新增文件夹必填
                // 新增图片
                showImgModalStatus: false,
                imgInfo: {
                    media_name: "",
                    category_id: 0,
                    // path: '',
                    // thumb: "",
                    // video: "",
                    tags: [
                        {
                            tag: ""
                        }
                    ]
                },
                imgInfoValidate: {
                    media_name: [
                        {required: true, message: "请输入名称", trigger: "blur"}
                    ],
                    thumb: [
                        {required: true, validator: validateThumb, trigger: "change"}
                    ],
                    video: [
                        {required: true, validator: validateVideo, trigger: "change"}
                    ],
                    file: [{required: true, validator: validateFile, trigger: "change"}]
                },
                thumblist: [],
                videoList: [],
                fileList: [],
                removeStatus: false, //删除状态
                renameStatus: false, // 编辑状态
                renameId: null, // 编辑id
                //   文件列表
                list: [],
                floderDetail: null,
                adminInfo: {
                    id: "", //人员id
                    section: {
                        id: "" //部门id
                    }
                },
                downItem: null,
                downId: null,
                downType: null,
                enterid: null,
                enterType: null,
                isdown: false,
                isyi: false,
                isenter: false,
                pList: [], //子集列表
                categories: [],
                bread_crumbs: [],
                back_id: 0
            };
        },
        components: {
            UploadThumb,
            SliceUploadVideo,
            UploadFile
        },
        created() {
            // 文件列表
            // this.getIndex();
            // this.getDetail();
            // this.getBmList();
            // this.getSortList();
            this.parentid = parseInt(
                !this.$route.query.parentid ? 0 : this.$route.query.parentid
            );
            this.getIndex(); //首页列表
        },
        methods: {
            copyLink(name) {
                var inputShareLink = document.createElement("input");
                if (name === 'share-link-code') {
                    inputShareLink.setAttribute("value", this.share_link_code);
                } else {
                    inputShareLink.setAttribute("value", this.share_link);
                }
                document.body.appendChild(inputShareLink);
                inputShareLink.select();
                document.execCommand("copy");
                document.body.removeChild(inputShareLink);
                this.$Message.success("复制成功");
            },
            getCategories() {
                this.$api.mediaCategory.all().then(res => {
                    if (res.code == 200) {
                        this.categories = res.result.categories;
                    }
                });
            },
            // 图片前缀
            addmin(url) {
                if (url.indexOf("http") == -1) {
                    url = this.$publicData.ossUrl + url;
                    return url;
                } else {
                    return url;
                }
            },
            // 部门接口
            getBmList() {
                this.$api.section.list({}).then(res => {
                    if (res.code == 200) {
                        this.sectionList = res.result.list;
                    } else {
                        this.$Message.error(res.message);
                    }
                });
            },
            // 点击部门共享
            toshow() {
                this.showbumenList = true;
                this.getSectionList();
            },
            //  点击分享
            toshowfen() {
                this.showshare = true;
            },
            //  点击创建链接
            tochuang() {
                this.tochuangLoading = true;
                this.$api.mediaShare.createsharelink({
                    media_id: this.floderDetail.id,
                    expire_in: this.animaltime,
                    code: this.mavalue,
                }).then(res => {
                    if (res.code == 200) {
                        this.tochuangLoading = false;
                        this.$Message.success(res.msg);
                        this.share_link = window.location.host + "/#/share/index?link=" + res.result.link;
                        this.share_link_code = res.result.code;
                        this.showlian = true;
                    }
                });
            },
            getSectionList() {
                this.$api.media.sectionlist().then(res => {
                    if (res.code == 200) {
                        this.sectionList = res.result.list;
                    }
                });
            },

            // 点击下载
            downloadImg(url) {
                console.log("url", url);
                var a = document.createElement("a");
                var event = new MouseEvent("click");
                // 自定义下载后图片的名称
                a.download = "图片";
                a.href = url;
                a.dispatchEvent(event);
            },
            // 点击部门确定
            submitbumen() {
                // console.log("qqq",this.bumen);
                var params = {
                    id: this.zhongId,
                    section_ids: this.bumen
                };
                this.$api.media.sectionshared(params).then(res => {
                    if (res.code == 200) {
                        this.showbumenList = false;
                        this.$Message.success(res.msg);
                    }
                });
            },
            // 点击部门取消
            cancelbumen() {
                this.showbumenList = false;
            },
            // 人、部门id
            getDetail() {
                var that = this;
                that.$api.admin
                    .detail({admin_id: this.$store.getters.user_id})
                    .then(res => {
                        if (res.code == 200) {
                            that.adminInfo = res.result;
                        } else {
                            that.$Message.error(res.message);
                        }
                    });
            },
            getIndex() {
                var that = this;
                that.floderDetail = null;
                that.zhongId = null;

                this.$api.media
                    .breadcrumblist({
                        parent_id: this.parentid
                    })
                    .then(res => {
                        if (res.code == 200) {
                            this.back_id = res.result.back_id;
                            this.bread_crumbs = res.result.bread_crumbs;
                        }
                    });

                var params = {
                    media_name: that.formItem.media_name, //文件名
                    tag: that.formItem.tag, //标签
                    parent_id: this.parentid
                };
                if (that.formItem.datetime.length > 0) {
                    params.start_time = that.formItem.datetime[0];
                    params.end_time = that.formItem.datetime[1];
                }
                that.$api.media.list(params).then(res => {
                    if (res.code == 200) {
                        var arr = res.result.list;
                        for (var i in arr) {
                            arr[i].single = false;
                        }
                        that.list = arr;
                    }
                });
            },
            // 上传时间改变
            changeDate(val) {
                if (val[1].slice(-8) === "00:00:00") {
                    val[1] = val[1].slice(0, -8) + "23:59:59";
                    this.formItem.datetime = val;
                }
                this.formItem.datetime = val;
            },
            //   鼠标移入事件
            mouseOver(index, id) {
                document
                    .getElementsByClassName("file_item")
                    [index].getElementsByClassName("zhezhao")[0].style.display = "block";
            },
            // 鼠标移出事件
            mouseLeave() {
                var item = document.getElementsByClassName("file_item");
                for (var i = 0; i < this.list.length; i++) {
                    if (this.list[i].single == true) {
                        item[i].getElementsByClassName("zhezhao")[0].style.display = "block";
                        this.zhongId = this.list[i].id;
                    } else {
                        item[i].getElementsByClassName("zhezhao")[0].style.display = "none";
                    }
                }
            },
            // 改变多选框
            changeCheck(e, index, id) {
                // console.log("changeCheck",e,id);
                this.floderDetail = null;
                if (e == true) {
                    this.zhongId = id;
                    for (var i in this.list) {
                        this.list[i].single = false;
                    }
                    this.list[index].single = true;
                    this.mouseLeave();
                    this.$api.media.detail({id: id}).then(res => {
                        if (res.code == 200) {
                            this.floderDetail = res.result.detail;
                            // this.classsName = "";
                            // for (var s in this.sortList) {
                            //     if (
                            //         this.floderDetail.classs != 0 &&
                            //         this.sortList[s].id == this.floderDetail.classs
                            //     )
                            //         this.classsName = this.sortList[s].name;
                            // }
                            // this.bumen = this.floderDetail.department;
                            if (this.floderDetail.file_type == "pic") {
                                this.fjway = "pic";
                            } else if (this.floderDetail.file_type == "video") {
                                this.fjway = "video";
                            } else {
                                this.fjway = "file";
                            }
                        }
                    });
                } else {
                    this.zhongId = null;
                    this.floderDetail = null;
                }
            },
            // 点击文件夹
            findChind(id) {
                if (id == -1) {
                    if (this.back_id > 0) {
                        this.parentid = this.back_id;
                        this.$router.push("/media/index?parentid=" + this.back_id);
                        this.getIndex();
                    } else {
                        this.parentid = 0;
                        this.$router.push("/media/index");
                        this.getIndex();
                    }
                } else if (id > 0) {
                    //   进入子集
                    this.parentid = id;
                    this.$router.push("/media/index?parentid=" + id);
                    this.getIndex();
                } else {
                    // 进入首页
                    this.parentid = 0;
                    this.$router.push("/media/index");
                    this.getIndex();
                }
            },
            // 点击新建
            newFolder() {
                for (var i in this.list) {
                    this.list[i].single = false;
                }
                this.zhongId = null;
                this.floderDetail = null;
                this.ftitle = "新建文件夹";
                this.showModalStatus = true;
                this.addInfo = {
                    media_name: "",
                    tags: [
                        {
                            tag: ""
                        }
                    ]
                };
            },
            // 新建文件夹点击取消
            handleReset() {
                this.showModalStatus = !this.showModalStatus;
            },
            // 上传图片点击取消
            handleImgReset() {
                this.showImgModalStatus = !this.showImgModalStatus;
            },
            // 新建/编辑文件夹点击提交
            handleSubmit(name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        let ps = {
                            media_name: this.addInfo.media_name,
                            type: 1,
                            parent_id: this.parentid
                        };
                        let tags = [];
                        this.addInfo.tags.forEach(item => {
                            if (item.tag !== "") {
                                tags.push(item);
                            }
                        });
                        ps.tags = JSON.stringify(tags);

                        if (this.zhongId !== null && this.zhongId > 0) {
                            ps.id = this.zhongId;
                            this.$api.media.edit(ps).then(res => {
                                if (res.code == 200) {
                                    this.$Message.success(res.msg);
                                    this.showModalStatus = !this.showModalStatus;
                                    this.getIndex();
                                }
                            });
                        } else {
                            this.$api.media.create(ps).then(res => {
                                if (res.code == 200) {
                                    this.$Message.success(res.msg);
                                    this.showModalStatus = !this.showModalStatus;
                                    this.getIndex();
                                }
                            });
                        }
                    } else {
                        this.$Message.error("请检查输入的信息是否正确！");
                    }
                });
            },
            // 点击上传图片提交
            handleImgSubmit(name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        let path = "";
                        if (this.fjway == "pic") {
                            path = this.$refs["uploadthumb"].uploadList[0].url;
                        } else if (this.fjway == "video") {
                            path = this.$refs["sliceuploadvideo"].videoList[0].url;
                        } else {
                            path = this.$refs["UploadFiles"].filesList[0].url;
                        }
                        let ps = {
                            media_name: this.imgInfo.media_name,
                            type: 2,
                            parent_id: this.parentid,
                            category_id: this.imgInfo.category_id,
                            path: path
                        };
                        let tags = [];
                        this.imgInfo.tags.forEach(item => {
                            if (item.tag !== "") {
                                tags.push(item);
                            }
                        });
                        ps.tags = JSON.stringify(tags);

                        if (this.floderDetail !== null && this.floderDetail.id > 0) {
                            ps.id = this.floderDetail.id;
                            this.$api.media.edit(ps).then(res => {
                                if (res.code == 200) {
                                    this.$Message.success(res.msg);
                                    this.showImgModalStatus = !this.showImgModalStatus;
                                    this.getIndex();
                                }
                            });
                        } else {
                            this.$api.media.create(ps).then(res => {
                                if (res.code == 200) {
                                    this.$Message.success(res.msg);
                                    this.showImgModalStatus = !this.showImgModalStatus;
                                    this.getIndex();
                                }
                            });
                        }
                    } else {
                        this.$Message.error("请检查输入的信息是否正确！");
                    }
                });
            },
            // 添加标签
            addLable() {
                // console.log(this.addInfo);
                this.addInfo.tags.push({
                    tag: ""
                });
            },
            // 删除标签
            deleteLable(index) {
                var that = this;
                that.addInfo.tags.splice(index, 1);
            },
            // 添加标签
            addImgLable() {
                this.imgInfo.tags.push({
                    tag: ""
                });
            },
            // 删除标签
            deleteImgLable(index) {
                var that = this;
                that.imgInfo.tags.splice(index, 1);
            },
            // 点击上传
            newImg() {
                for (var i in this.list) {
                    this.list[i].single = false;
                }
                this.zhongId = null;
                this.floderDetail = null;
                this.fjway = "pic";
                this.pictitle = "上传文件";
                this.imgInfo = {
                    name: "",
                    thumb: "",
                    video: "",
                    tags: [
                        {
                            tags: ""
                        }
                    ]
                };
                this.thumblist = [];
                this.videoList = [];
                this.fileList = [];
                if (this.$refs["uploadthumb"]) {
                    this.$refs["uploadthumb"].handleClearFiles();
                    this.$refs["uploadthumb"].uploadList = [];
                    // that.$refs["uploadthumb"].uploadStatus = true;
                    // that.$refs["uploadthumb"].showUpload = false;
                    // that.$refs["uploadthumb"].file = null;
                }
                if (this.$refs["sliceuploadvideo"]) {
                    this.$refs["sliceuploadvideo"].handleClearFiles();
                    this.$refs["sliceuploadvideo"].videoList = [];
                    this.$refs["sliceuploadvideo"].uploadStatus = true;
                    this.$refs["sliceuploadvideo"].showUpload = false;
                    this.$refs["sliceuploadvideo"].file = null;
                }
                if (this.$refs["UploadFiles"]) {
                    this.$refs["UploadFiles"].handleClearFiles();
                    this.$refs["UploadFiles"].fileList = [];
                }
                this.getCategories();
                this.showImgModalStatus = true;
            },
            getname(data) {
                this.imgInfo.media_name = data;
            },
            // 点击删除
            clickRemove() {
                this.$Modal.confirm({
                    title: "警告",
                    content: "<p>此操作不可恢复，三思而后行...</p>",
                    onOk: () => {
                        this.$api.media.remove({id: this.zhongId}).then(res => {
                            if (res.code == 200) {
                                this.$Message.success(res.msg);
                                // this.getIndex();
                                // if (this.parentid != 0) {
                                //     this.getList(); //子集列表
                                // } else {
                                this.getIndex(); //首页列表
                                // }
                            } else {
                                this.$Message.error(res.msg);
                            }
                        });
                    }
                });
            },
            // 点击编辑
            clickRename() {
                var that = this;
                // 编辑文件夹
                if (that.floderDetail.type == 1) {
                    that.ftitle = "编辑文件夹";
                    that.showModalStatus = true;
                    that.addInfo.media_name = that.floderDetail.media_name;
                    that.addInfo.tags = [];
                    if (that.floderDetail.tags && that.floderDetail.tags.length > 0) {
                        for (var i in that.floderDetail.tags) {
                            that.addInfo.tags.push({tag: that.floderDetail.tags[i].tag});
                        }
                    }
                } else {
                    // 编辑图片
                    that.pictitle = "编辑文件";
                    that.showImgModalStatus = true;
                    this.getCategories();
                    // that.fjway = that.floderDetail.suffix;
                    // setTimeout(function () {
                    that.thumblist = [];
                    if (that.$refs["uploadthumb"]) {
                        that.$refs["uploadthumb"].handleClearFiles();
                        that.$refs["uploadthumb"].uploadList = [];
                        // that.$refs["uploadthumb"].uploadStatus = true;
                        // that.$refs["uploadthumb"].showUpload = false;
                        // that.$refs["uploadthumb"].file = null;
                    }
                    that.videoList = [];
                    if (that.$refs["sliceuploadvideo"]) {
                        that.$refs["sliceuploadvideo"].handleClearFiles();
                        that.$refs["sliceuploadvideo"].videoList = [];
                        that.$refs["sliceuploadvideo"].uploadStatus = true;
                        that.$refs["sliceuploadvideo"].showUpload = false;
                        that.$refs["sliceuploadvideo"].file = null;
                    }
                    that.fileList = [];
                    if (that.$refs["UploadFiles"]) {
                        that.$refs["UploadFiles"].handleClearFiles();
                        that.$refs["UploadFiles"].fileList = [];
                    }

                    // if (
                    //     that.floderDetail.suffix != "pic" &&
                    //     that.floderDetail.suffix != "video"
                    // ) {
                    //     that.fjway = "file";
                    // }
                    if (that.fjway == "pic") {
                        that.thumblist.push({
                            name: "图片文件",
                            url: that.floderDetail.path,
                            status: "finished"
                        });
                    }
                    if (that.fjway == "video") {
                        // console.log("shipin", that.floderDetail);
                        // that.videoList = [];
                        that.videoList.push({
                            name: that.floderDetail.filename,
                            url: that.floderDetail.path,
                            status: "finished",
                            fullurl: that.addmin(that.floderDetail.path)
                        });
                        // console.log("that.videoList", that.videoList);
                        that.$refs["sliceuploadvideo"].uploadStatus = false;
                    }
                    if (that.fjway == "file") {
                        that.fileList = [];
                        that.fileList.push({
                            name: that.floderDetail.filename,
                            url: that.floderDetail.path,
                            status: "finished"
                        });
                    }

                    that.imgInfo.media_name = that.floderDetail.media_name;
                    that.imgInfo.category_id = that.floderDetail.category_id;
                    // that.imgInfo.labels=[{lable:"标签"},{lable:"标签"}]
                    // labels: ["标签1"]
                    that.imgInfo.tags = [];
                    if (that.floderDetail.tags && that.floderDetail.tags.length > 0) {
                        for (var i in that.floderDetail.tags) {
                            that.imgInfo.tags.push({tag: that.floderDetail.tags[i].tag});
                        }
                    }
                    // }, 300);
                }
            },
            // 文件夹/图片按下
            mousedown(item) {
                // console.log("mousedown", item);
                // this.isX = true;
                this.isdown = true;
                this.downId = item.id;
                this.downType = item.type;
                this.downItem = item;
                // console.log("down",item.id);
            },
            // 文件夹/图片移动
            mouseleave(id, type) {
                if (this.isdown == false) return;
                this.isyi = true;
                this.enterid = null;
                // console.log("移动", this.isdown, this.isyi, this.isenter, this.enterid);
                // console.log(id);
            },
            // 进入其他文件夹/图片
            mouseenter(id, type) {
                if (this.isyi == false) return;
                // console.log("进入其他文件夹", this.isdown, this.isyi, this.isenter);
                // console.log(id);
                this.isenter = true;
                this.enterid = id;
                this.enterType = type;
            },
            //抬起
            greet(val) {
                if (
                    this.isdown &&
                    this.isyi &&
                    this.isenter &&
                    this.downId &&
                    this.enterid &&
                    this.downId != this.enterid
                ) {
                    // console.log("greet", this.downItem);
                    // if (this.enterType == 1) {
                    //     return;
                    // } else {
                    // if (this.downItem.publics) {
                    //   this.$Message.success("此文件为分享文件，可复制");
                    // }
                    var params = {
                        id: this.downId,
                        // name: this.downItem.name,
                        // classs: this.downItem.classs, //分类
                        // type: this.downItem.type, //文件
                        // did: this.adminInfo.section.id, //部门id
                        // uid: this.adminInfo.id, //上传人id
                        parent_id: this.enterid //上级id
                        // labels: this.downItem.labels,
                        // suffix: this.downItem.suffix,
                        // url: this.downItem.path
                    };
                    this.$api.media.move(params).then(res => {
                        if (res.code == 200) {
                            // this.getIndex();
                            // if (this.parentid != 0) {
                            //     this.getList(); //子集列表
                            // } else {
                            this.getIndex(); //首页列表
                            // }
                            this.isdown == false;
                            this.isyi == false;
                            this.isenter == false;
                            this.$Message.success(res.msg);
                        }
                    });
                    // }
                }
            }
        },
        watch: {}
    };
</script>

<style scoped>
    /* .ivu-form-item{
            margin-bottom: 0;
        } */
    .item_list {
        margin-left: 10px;
        display: flex;
        width: auto;
        height: auto;
        padding-top: 20px;
        padding-bottom: 20px;
        /* justify-content: space-between; */
        flex-wrap: wrap;
        flex: 1;
    }

    .wenzi {
        font-size: 16px;
        line-height: 30px;
    }

    .btn_view > span {
        display: block !important;
    }

    .btn_view {
        color: #0084ff;
        background: #e2f2ff;
        border-color: transparent;
        font-size: 16px;
    }

    .btn_view:hover {
        color: #0084ff;
        background: #e2f2ff;
        border-color: transparent;
    }

    .btn_view.ivu-btn:hover {
        color: #0084ff;
        background: #e2f2ff;
        border-color: transparent;
    }

    .btn_view .btn_wrap {
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .btn_view .btn_wrap .btn_icon {
        margin-right: 6px;
    }

    .btn_view.add_btn {
        background: #fff2e8;
        color: #ff9011;
    }

    .btn_view.add_btn:hover {
        color: #ff9011;
        background: #fff2e8;
        border-color: transparent;
    }

    .btn_view.search_all_btn {
        background: #0084ff;
        color: #ffffff;
    }

    .btn_view.search_all_btn:hover {
        color: #ffffff;
        background: #0084ff;
    }

    .btn_view.rename_btn {
        background: #e2f2ff;
        color: #0084ff;
    }

    .btn_view.rename_btn:hover {
        color: #0084ff;
        background: #e2f2ff;
        border-color: transparent;
    }

    .btn_view.rename_btn.clicked {
        color: #0084ff;
        background: #ffffff;
        border-color: #0084ff;
    }

    .btn_view.remove_btn {
        background: #ffe2e2;
        color: #f21d1d;
    }

    .btn_view.remove_btn:hover {
        color: #f21d1d;
        background: #ffe2e2;
        border-color: transparent;
    }

    .btn_view.remove_btn.clicked {
        color: #f21d1d;
        background: #ffffff;
        border-color: #f21d1d;
    }

    /deep/ .ivu-form .ivu-select span {
        display: block;
        height: 32px;
    }

    .mbx li {
        float: left;
        padding-left: 10px;
        max-width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .mbx li .back {
        width: 13px;
        margin-right: 5px;
        cursor: pointer;
    }

    li a {
        color: #afb3bf;
    }

    .mbx li:last-child a {
        color: #000;
    }

    .mbx li:not(:last-child) a::after {
        display: inline;
        content: ">";
        margin-left: 10px;
    }

    .foldercon {
        display: flex;
    }

    .foldercon .folderRight {
        min-height: 200px;
        width: 330px;
        background: #f6f6f6;
        border-radius: 5px;
        margin: 20px 0;
        padding: 20px 25px;
        position: relative;
    }

    .foldercon .folderRight h3 {
        font-size: 14px;
        color: #000;
        font-weight: 400;
        margin-bottom: 20px;
    }

    .foldercon .folderRight .picbox {
        /* width: 100%; */
        background: #fff;
        height: 140px;
        text-align: center;
        display: table-cell;
        vertical-align: middle;
        width: 275px;
    }

    .foldercon .folderRight span,
    .foldercon .folderRight i {
        font-size: 14px;
        color: #333;
        line-height: 35px;
        font-style: unset;
    }

    .foldercon .folderRight i {
        margin-left: 5px;
    }

    .foldercon .folderRight .name {
        margin: 20px 0;
    }

    .foldercon .folderRight .picbox .pic {
        margin: 0 auto;
        /* height: 100%; */
        max-width: 100%;
        max-height: 100%;
        /* width: auto; */
        /* height: 100%; */
        /* width: auto; */
        /* max-width: 251px; */
    }

    .foldercon .folderRight .ivu-tag {
        border-radius: 8px;
        margin: 0 5px;
    }

    .file_item {
        /* flex: 1; */
        margin-right: 20px;
        width: 130px;
        margin-top: 5px;
        margin-bottom: 5px;
        position: relative;
        float: left;
    }

    .file_item .item_wrap {
        width: 100%;
        padding: 35px 0;
        text-align: center;
        position: relative;
        user-select: none;
    }

    .file_item .zhezhao {
        position: absolute;
        background: #f6f6f6;
        width: 130px;
        height: 160px;
        top: 0;
        padding: 10px;
    }

    .file_item .zhezhao .ivu-checkbox-wrapper {
        position: absolute;
        right: 8px;
        z-index: 100;
    }

    .file_item .item_tu_wrap {
        width: 58px;
        height: 58px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .file_item .tu_folder {
        width: 44px;
        height: 37px;
    }

    .file_item .item_tu {
        width: 58px;
        height: 58px;
        border-radius: 4px;
        object-fit: contain;
    }

    .file_item.custom_select {
        background: #f6f6f6;
        border-radius: 5px;
    }

    .file_item .item_wrap .select_icon {
        width: 14px;
        height: 14px;
        /*background: #DF3434;*/
        border: 0 none;
        border-radius: 2px;
        position: absolute;
        right: 8px;
        top: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .file_item .item_wrap .remove_icon {
        width: 14px;
        height: 14px;
        /*background: #DF3434;*/
        border: 0 none;
        border-radius: 2px;
        position: absolute;
        right: 8px;
        top: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .file_item .item_wrap .select_icon.wait_rename {
        /*border: 2px solid #DF3434;*/
        /*background: transparent;*/
    }

    .nofloder span {
        display: block;
        text-align: center;
        font-style: 16px;
        color: #000;
    }

    .nofloder {
        text-align: center;
        position: absolute;
        top: 50%;
        margin-top: -70px;
        width: 280px;
    }

    .title {
        /* width: 100px; */
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        height: 20px;
    }
</style>